var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconRedo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_10083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75646 9.98519C1.75646 13.3018 4.45491 16 7.77129 16H9.90043C10.2533 16 10.5392 15.7141 10.5392 15.3613V15.1484C10.5392 14.7955 10.2533 14.5096 9.90043 14.5096H7.77129C5.27662 14.5096 3.24686 12.4799 3.24686 9.98519C3.24686 7.49052 5.27662 5.46075 7.77129 5.46075H11.6994L8.99412 8.16606C8.70356 8.45652 8.70356 8.92938 8.99412 9.21984C9.27607 9.50157 9.76675 9.50115 10.0481 9.21984L14.0253 5.24252C14.166 5.10177 14.2436 4.91463 14.2436 4.71552C14.2436 4.51656 14.166 4.32931 14.0253 4.18864L10.0479 0.211143C9.76654 -0.070381 9.27543 -0.070381 8.99409 0.211143C8.70352 0.501531 8.70352 0.974455 8.99409 1.26481L11.6994 3.97033H7.77129C4.45491 3.97033 1.75646 6.66867 1.75646 9.98519Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_10083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRedo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-redo.73e7f66d.svg";
export { ForwardRef as ReactComponent };